'use client';
import React, { forwardRef, ReactNode, MouseEvent } from 'react';
import { LinkProps as NextLinkProps } from 'next/link';
import { useRouter, getLinkComponent } from '../../utils/routing';
import { Link as MuiLink } from '@mui/material';

type Props = NextLinkProps & {
  prefetch?: boolean;
  children?: ReactNode;
  defaultLocale?: string;
};

export type LinkBehaviourProps = Omit<Props, 'defaultLocale'>;

const LinkBehaviour = forwardRef<HTMLAnchorElement, Props>(
  function LinkBehaviour(props, ref) {
    const router = useRouter();
    let href = props.href.toString();
    const isExternalLink = href.startsWith('http');
    const isModal = href.startsWith('/modal/');
    const LinkComponent = getLinkComponent(props.defaultLocale);
    const modalHref = href;
    href = isModal ? href.replace('/modal', '') : href;
    const onClick = (e?: MouseEvent<HTMLAnchorElement>) => {
      if (isModal) {
        e?.preventDefault();

        router.push(modalHref, { scroll: false });
      }
      props.onClick?.(e as any);
    };
    if (isExternalLink) {
      return (
        <MuiLink
          component={'a'}
          sx={{
            color: 'inherit',
            textDecoration: 'hover',
            fontSize: 'inherit',
          }}
          rel={'noopener noreferrer'}
          {...props}
          href={href}
        >
          {props.children}
        </MuiLink>
      );
    }
    return (
      <LinkComponent
        ref={ref}
        {...props}
        href={href}
        onClick={onClick}
        locale={props.locale ? `${props.locale}` : undefined}
      />
    );
  },
);

export default LinkBehaviour;
